class RidgePredictor {
    constructor() {
        this.model = null;
        this.isLoaded = false;
    }

    async loadModel() {
        try {
            const response = await fetch('/ridge_model.json');
            this.model = await response.json();
            this.isLoaded = true;
            return true;
        } catch (error) {
            console.error('Error loading model:', error);
            return false;
        }
    }

    standardizeFeatures(inputData) {
        const scaledData = { ...inputData };
        
        // Scale only the numerical features
        this.model.scaling_columns.forEach((col, index) => {
            if (inputData[col] !== undefined) {
                scaledData[col] = (inputData[col] - this.model.scaler_mean_[index]) / this.model.scaler_scale_[index];
            }
        });

        return scaledData;
    }

    predict(inputData) {
        if (!this.isLoaded) {
            throw new Error('Model not loaded. Call loadModel() first.');
        }

        // Standardize numerical features
        const scaledData = this.standardizeFeatures(inputData);

        // Ensure all features are present in the correct order
        const features = this.model.feature_names.map(featureName => {
            return scaledData[featureName] || 0;
        });

        // Calculate prediction: y = X * coef + intercept
        let prediction = this.model.intercept_;
        for (let i = 0; i < features.length; i++) {
            prediction += features[i] * this.model.coef_[i];
        }

        return prediction;
    }
}

export default RidgePredictor;